import { render, staticRenderFns } from "./NatureOfBusinessISICView.vue?vue&type=template&id=0b26d762&scoped=true&"
import script from "./NatureOfBusinessISICView.vue?vue&type=script&lang=js&"
export * from "./NatureOfBusinessISICView.vue?vue&type=script&lang=js&"
import style0 from "./NatureOfBusinessISICView.vue?vue&type=style&index=0&id=0b26d762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b26d762",
  null
  
)

export default component.exports